import { Helper } from '../Helper';
export class DebugLogHelper extends Helper {
    constructor(options) {
        super();
        this.count = options.count;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitPushInt(node, this.count);
        sb.emitOp(node, 'PACK');
        sb.emitHelper(node, options, sb.helpers.consoleLog);
    }
}

//# sourceMappingURL=DebugLogHelper.js.map
